import script from "./InfoEmpleado.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoEmpleado.vue?vue&type=script&setup=true&lang=js"

import "./InfoEmpleado.vue?vue&type=style&index=0&id=26c87d00&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c87d00"]])

export default __exports__